module.exports = __webpack_public_path__ + "static/media/male-front-calves-calves-a.3f4d8a21.png";